import { concat } from 'lodash';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  useGetAssemblies,
  useParamQuery,
  useUpdateAssemblyWithAssemblyTags,
} from 'src/hooks';
import { useCreateAssemblyTag } from 'src/hooks/api/assemblyTags/useCreateAssemblyTag';
import { formatQuery } from 'src/utils';

export const useCreateAssemblyTagPage = () => {
  const { onChangeParams } = useParamQuery();
  const location = useLocation();

  const {
    data: assembliesData,
    isLoading: isLoadingAssemblies,
    error: errorLoadingAssemblies,
    hasNextPage,
    fetchNextPage,
  } = useGetAssemblies(
    concat(formatQuery(location.search), ['sort=-created_at']),
  );

  const createAssemblyTag = useCreateAssemblyTag();
  const updateAssembly = useUpdateAssemblyWithAssemblyTags();

  const getNextAssemblyPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage]);

  return {
    assembliesData,
    isLoadingAssemblies,
    errorLoadingAssemblies,
    hasNextPage,
    fetchNextPage,
    getNextAssemblyPage,
    onChangeParams,
    createAssemblyTag,
    updateAssembly,
  };
};
